<template>
  <slide-view
    modal
    appendToBody
    modalAppendToBody
    v-empty="!canShowDetail"
    :listener-ids="listenerIDs"
    :no-listener-ids="noListenerIDs"
    :no-listener-class="noListenerClass"
    :body-style="{padding: 0, height: id ? '100%' : '100vh'}"
    xs-empty-icon="nopermission"
    xs-empty-text="暂无权限"
    :slide-fade="id?'slide-fade':''"
    @afterEnter="viewAfterEnter"
    @close="hideView">
    <div
      ref="crmDetailMain"
      v-loading="loading"
      class="detail-main no-padding">
      <flexbox
        v-if="canShowDetail && detailData"
        direction="column"
        align="stretch"
        class="d-container">
        <c-r-m-detail-head
          :id="detailId"
          ref="crmDetailHead"
          :class="{'is-shadow': bodyIsScroll}"
          :is-seas="isSeasDetail"
          :detail="detailData"
          :handles="activityHandle"
          :model-data="modelData"
          :pool-id="seasPoolId"
          :pool-auth="poolAuth"
          :crm-type="crmType"
          :tag-info="tagInfo"
          :page-list="pageList"
          @create-success="editSaveSuccess"
          @pageChange="pageChange"
          @handle="detailHeadHandle"
          @close="hideView">
          <template slot="appreciation-examine">
            <!-- 转为精准企业 -->
            <el-button
              v-for="(item,index) in examineButtons"
              :key="index"
              class="head-handle-button"
              type="primary"
              @click="handleExamineClick(item)">{{ item.examineName }}</el-button>
          </template>
          <!-- <el-button
            slot="appreciation-call"
            class="wk-premium-info-btn"
            data-type="Call">
            <i class="wk wk-icon-lightning-solid wk-premium-info-icon" data-type="Call" />
            <span class="wk-premium-info-label" data-type="Call">呼叫中心</span>
          </el-button> -->
          <template slot="name">
            <i v-if="detailData.status == 2" class="wk wk-circle-password" />
            <crm-tooltip v-if="!isSeasDetail" :content="detailData.star == 0 ? '添加关注' : '取消关注'" effect="dark" placement="top">
              <i
                v-if="detailData.star == 0"
                class="el-icon-star-off focus-icon"
                @click="toggleStar()" />
              <i
                v-else
                class="wk wk-focus-on focus-icon active"
                @click="toggleStar()" />
            </crm-tooltip>
          </template>
        </c-r-m-detail-head>

        <div class="d-container-body" @scroll="bodyScroll">
          <detail-head-base :list="headDetails" @action="headAction" />
          <relative-stage-records
            v-if="statusShow"
            :id="detailId"
            :is-seas="isSeasDetail"
            :crm-type="crmType"
            :detail="detailData"
            @handle="detailHeadHandle"
          />
          <flexbox class="left-right-wrap" align="stretch">
            <div class="left">
              <el-tabs
                v-if="pagesInsertComplete"
                v-model="tabCurrentName"
                nav-mode="more"
              >
                <el-tab-pane
                  v-for="(item, index) in tabNames"
                  :key="index"
                  :label="item.label"
                  :name="item.name"
                  lazy>
                  <template slot="label">
                    <el-badge
                      :value="item.num"
                      :hidden="item.num <= 0"
                      type="info">
                      {{ item.label }}
                    </el-badge>
                  </template>
                  <!-- 工商信息 -->
                  <business-info-view
                    v-if="item.name === 'BusinessInfoView'"
                    :name="detailData.customerName"
                    style="padding: 0;"
                    :props="{ fillBtnShow: false, isFixed: false, style: {padding: 0, marginBottom: '16px'}, closeShow: false }"
                  />
                  <crm-webview v-else-if="item.url" :key="index" :iframe-path="item.url" />
                  <component
                    :is="item.name"
                    v-else
                    :id="detailId"
                    :ref="item.name"
                    :detail="detailData"
                    :type-list="logTyps"
                    :pool-id="seasPoolId"
                    :handle="activityHandle"
                    :is-seas="isSeasDetail"
                    :crm-type="crmType"
                    :contacts-id.sync="firstContactsId"
                    :ignore-fields="['customerName']"
                    @refresh="getDetial"
                    @handle="detailHeadHandle" />
                </el-tab-pane>
              </el-tabs>

            </div>
            <div v-if="detailData && detailData.digest" class="right">
              <wk-head-section label="客户摘要">
                <div class="abstract">
                  <wk-section-item
                    v-for="(item, index) in abstractList"
                    :key="index"
                    :label="item.title">
                    <!-- <i
                      v-if="item.helpType"
                      slot="otherLabel"
                      class="wk wk-icon-fill-help wk-help-tips"
                      :data-type="item.helpType"
                      :data-id="item.helpId"
                      @click.stop="" /> -->
                    {{ getDigestFieldValue(item) }}
                  </wk-section-item>
                </div>
              </wk-head-section>
            </div>
          </flexbox>
        </div>
      </flexbox>
    </div>
    <c-r-m-all-create
      v-if="isCreate"
      :action="createActionInfo"
      :crm-type="createCRMType"
      @save-success="editSaveSuccess"
      @close="isCreate=false" />

    <examine-create-view
      v-if="isExamineCreate"
      :category-id="createExamineInfo.categoryId"
      :type="createExamineInfo.type"
      :hide-business="true"
      :category-title="createExamineInfo.categoryTitle"
      :action="createExamineAction"
      :content="createExamineInfo.content"
      @hiden-view="isExamineCreate = false"
      @save-success="saveExamineSuccess" />

    <ExamineRemarkDialog
      :show="showExamineRemark"
      :title="`${examineInfo.examineName}审批`"
      placeholder="请输入取消理由（必填）"
      @close="showExamineRemark = false"
      @confirm="examineCancelComplete"
    />
    <!-- 审批详情 -->
    <ExamineDetail
      v-if="showExamineDetail"
      :id="examineId"
      @handle="detailHeadHandle"
      @hide-view="showExamineDetail=false" />
  </slide-view>
</template>

<script>
import { crmCustomerReadAPI } from '@/api/crm/customer'
import { crmSpecialExamineAPI, crmPagesInsertDetailListAPI } from '@/api/crm/common'

import SlideView from '@/components/SlideView'
import CRMDetailHead from '../components/CRMDetailHead'
import RelativeStageRecords from '../components/RelativeStageRecords' // 阶段记录
import Activity from '../components/Activity' // 活动
import CRMEditBaseInfo from '../components/CRMEditBaseInfo' // 基本信息
import RelativeContacts from '../components/RelativeContacts' // 相关联系人
import RelativeBusiness from '../components/RelativeBusiness' // 相关商机
import RelativeContract from '../components/RelativeContract' // 相关合同
import RelativeReturnMoney from '../components/RelativeReturnMoney' // 相关回款
import RelativeFiles from '../components/RelativeFiles' // 相关附件
import RelativeHandle from '../components/RelativeHandle' // 相关操作
import RelativeTeam from '../components/RelativeTeam' // 团队成员
import RelativeVisit from '../components/RelativeVisit' // 回访
import RelativeInvoice from '../components/RelativeInvoice' // 发票
import RelativeCallRecord from '../components/RelativeCallRecord' // 呼叫记录
import RelativeAddress from '../components/RelativeAddress' // 相关地址
import RelativeExamine from '../components/RelativeExamine' // 相关费用
import RelativeForwhomCustomer from '../components/RelativeForwhomCustomer' // 上下级客户
import BusinessInfoView from '@/components/Premium/BusinessInfo/View'
import CrmWebview from '../components/Webview/index' // iframe容器
import ExamineCreateView from '@/wkcrmViews/oa/examine/components/ExamineCreateView'
import ExamineDetail from '@/wkcrmViews/oa/examine/components/ExamineDetail'
import ExamineRemarkDialog from '../components/ExamineRemarkDialog' // 审批备注弹窗

import CRMAllCreate from '../components/CRMAllCreate' // 新建页面
import DetailMixin from '../mixins/Detail'
import ExamineMixin from '../mixins/Examine'

import { mapGetters } from 'vuex'
import { separator } from '@/filters/vueNumeralFilter/filters'

export default {
  // 客户管理 的 客户详情
  name: 'CustomerDetail',
  components: {
    SlideView,
    Activity,
    RelativeStageRecords,
    CRMDetailHead,
    CRMEditBaseInfo,
    RelativeContacts,
    RelativeBusiness,
    RelativeContract,
    RelativeReturnMoney,
    RelativeFiles,
    RelativeHandle,
    RelativeTeam,
    RelativeVisit,
    CRMAllCreate,
    RelativeInvoice,
    RelativeCallRecord,
    RelativeAddress,
    RelativeExamine,
    RelativeForwhomCustomer,
    BusinessInfoView,
    CrmWebview,
    ExamineCreateView,
    ExamineRemarkDialog,
    ExamineDetail
  },
  mixins: [DetailMixin, ExamineMixin],
  props: {
    // 详情信息id
    id: [String, Number],
    poolId: [String, Number],
    // 监听的dom 进行隐藏详情
    listenerIDs: {
      type: Array,
      default: () => {
        return ['crm-main-container']
      }
    },
    // 不监听
    noListenerIDs: {
      type: Array,
      default: () => {
        return []
      }
    },
    noListenerClass: {
      type: Array,
      default: () => {
        return ['el-table__body']
      }
    },
    /** 呼出信息 */
    modelData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showExamineDetail: false,
      examineId: null,
      showExamineRemark: false,
      // 展示加载loading
      loading: false,
      crmType: 'customer',
      headDetails: [],
      tabCurrentName: 'Activity',
      // 编辑操作
      createActionInfo: null,
      createCRMType: '',
      isCreate: false,
      isExamineCreate: false,
      createExamineInfo: {},
      createExamineAction: { type: 'save', data: {}},
      // 活动操作
      // 首要联系人信息
      firstContactsId: '',

      // 公海规则权限
      poolAuth: {},
      // 客户摘要字段
      abstractList: [
        { title: '跟进次数', field: 'activityCount', helpType: '8', helpId: '156', units: '次' },
        { title: '未跟进时长', field: 'notFollowUpDay', units: '天' },
        { title: '商机数量', field: 'businessCount' },
        { title: '商机总额', field: 'businessMoney', helpType: '8', helpId: '157', units: '元', isMoney: true },
        { title: '成交次数', field: 'contractCount', units: '次' },
        { title: '成交总额', field: 'contractMoney', units: '元', isMoney: true },
        { title: '回款总额', field: 'receivablesMoney', units: '元', isMoney: true },
        { title: '未回款总额', field: 'receivablesUnreceivedMoney', units: '元', isMoney: true },
        { title: '开票总额', field: 'invoiceMoney', units: '元', isMoney: true }
      ],

      // 审批按钮
      examineButtons: [],
      // 审批信息
      examineInfo: {},
      // 工商信息
      businessInfoViewShow: false,
      pagesInsertList: [], // tab嵌入页面列表
      pagesInsertComplete: false // 获取嵌入tab是否完成
    }
  },
  computed: {
    ...mapGetters(['isCall']),
    /**
     * 活动操作
     */
    activityHandle() {
      const temps = [
        {
          type: 'task',
          label: '创建任务',
          auth: 'oa.taskExamine'
        },
        {
          type: 'contacts',
          label: '创建联系人',
          auth: 'crm.contacts.save'
        },
        {
          type: 'business',
          label: '创建商机',
          auth: 'crm.business.save'
        },
        {
          type: 'contract',
          label: '创建合同',
          auth: 'crm.contract.save'
        },
        {
          type: 'receivables',
          label: '创建回款',
          auth: 'crm.receivables.save'
        }
      ]

      // if (this.canCreateFollowRecord) {
      //   temps = [{
      //     type: 'log',
      //     label: '写跟进'
      //   }].concat(temps)
      // }

      return temps
    },

    /**
     * tabs
     */
    tabNames() {
      var tempsTabs = []
      tempsTabs.push({ label: '活动', name: 'Activity' })
      if (this.crm.customer && this.crm.customer.read) {
        tempsTabs.push({ label: '详细资料', name: 'CRMEditBaseInfo' })
      }
      tempsTabs.push({ label: '工商信息', name: 'BusinessInfoView' })
      if (this.crm.contacts && this.crm.contacts.index) {
        tempsTabs.push({ label: '联系人', name: 'RelativeContacts', num: this.tabsNumber.contactCount })
      }

      tempsTabs.push({ label: '团队成员', name: 'RelativeTeam', num: this.tabsNumber.memberCount })

      const pagesInsertList = this.pagesInsertList
      if (Array.isArray(pagesInsertList) && pagesInsertList.length) {
        tempsTabs = tempsTabs.concat(pagesInsertList.map(item => {
          return { label: item.name, name: item.name, num: 0, url: item.url }
        }))
      }

      if (this.crm.business && this.crm.business.index) {
        tempsTabs.push({ label: '商机', name: 'RelativeBusiness', num: this.tabsNumber.businessCount })
      }

      if (this.crm.contract && this.crm.contract.index) {
        tempsTabs.push({ label: '合同', name: 'RelativeContract', num: this.tabsNumber.contractCount })
      }
      if ((this.crm.receivables && this.crm.receivables.index) || (this.crm.receivablesPlan && this.crm.receivablesPlan.index)) {
        tempsTabs.push({ label: '回款', name: 'RelativeReturnMoney', num: this.tabsNumber.receivablesCount })
      }
      if (this.crm.visit && this.crm.visit.index) {
        tempsTabs.push({ label: '回访', name: 'RelativeVisit', num: this.tabsNumber.returnVisitCount })
      }

      if (this.crm.invoice && this.crm.invoice.index) {
        tempsTabs.push({ label: '发票', name: 'RelativeInvoice', num: this.tabsNumber.invoiceCount })
      }

      tempsTabs.push({ label: '客户地址', name: 'RelativeAddress' })
      tempsTabs.push({ label: '费用', name: 'RelativeExamine' })
      tempsTabs.push({ label: '上下级客户', name: 'RelativeForwhomCustomer' })

      if (this.isCall) {
        tempsTabs.push({ label: '呼叫记录', name: 'RelativeCallRecord', num: this.tabsNumber.callRecordCount })
      }
      tempsTabs.push({ label: '附件', name: 'RelativeFiles', num: this.tabsNumber.fileCount })
      tempsTabs.push({ label: '操作记录', name: 'RelativeHandle', num: 0 })
      // if (this.statusShow) {
      //   tempsTabs.unshift({ label: '阶段记录', name: 'RelativeStageRecords' })
      // }
      return tempsTabs
    },
    /**
     * isSeas 是从公海模块传入的 配合详情is_pool字段确定
     */
    isSeasDetail() {
      if (this.detailData && this.detailData.hasOwnProperty('isPool')) {
        return this.detailData.isPool == 1
      }
      return this.isSeas
    },

    /**
     * 公海id
     */
    seasPoolId() {
      if (this.poolAuth && this.poolAuth.poolId) {
        return this.poolAuth.poolId
      }
      return this.poolId
    },

    /**
     * 根据记录筛选
     */
    logTyps() {
      let logTypslist = []
      logTypslist = [
        {
          icon: 'all',
          color: '#2362FB',
          command: '',
          label: '全部活动'
        },
        {
          icon: 'customer',
          color: '#487DFF',
          command: 2,
          label: '客户'
        },
        {
          icon: 'o-task',
          color: '#D376FF',
          command: 11,
          label: '任务'
        },
        {
          icon: 'business',
          color: '#FB9323',
          command: 5,
          label: '商机'
        },
        {
          icon: 'contract',
          color: '#FD5B4A',
          command: 6,
          label: '合同'
        },
        {
          icon: 'contacts',
          color: '#27BA4A',
          command: 3,
          label: '联系人'
        },
        {
          icon: 'receivables',
          color: '#FFB940',
          command: 7,
          label: '回款'
        },
        {
          icon: 'log',
          color: '#5864FF',
          command: 8,
          label: '日志'
        },
        {
          icon: 'approve',
          color: '#9376FF',
          command: 9,
          label: '审批'
        }
      ]
      if (this.$store.state.crm.isCall) {
        logTypslist.push({
          icon: 'phone',
          color: '#9376FF',
          command: 13,
          label: '呼叫记录'
        })
      }
      return logTypslist
    },
    /**
     * 详情ID
     */
    detailId() {
      return this.id || this.$route.query.id || null
    }
  },
  watch: {
    isCreate(newVal) {
      !newVal && (this.actionData = {})
    }
  },
  methods: {
    // 取消SKA/KA填写完取消理由
    examineCancelComplete(remark) {
      this.postSpecialExamine(this.examineInfo.examineType, { customerIds: this.detailId }, this.examineInfo.examineId, this.detailData.customerName, remark, () => {
        this.showExamineRemark = false
        // 更新详情
        this.getDetial()
        this.getTagInfo()
      })
    },
    saveExamineSuccess() {
      // 更新详情
      this.getDetial()
      this.getTagInfo()
    },
    getPageInsertList() {
      const params = {
        module: 2, // 模块  1 线索  2 客户  3 联系人
        businessId: this.detailId,
        platform: 1 // 端  1 PC  2 移动
      }
      crmPagesInsertDetailListAPI(params).then(res => {
        this.pagesInsertList = res.data || []
        this.pagesInsertComplete = true
      }).catch(() => {
        this.pagesInsertComplete = true
      })
    },
    /**
     * 详情
     */
    getDetial() {
      this.firstContactsId = ''
      this.loading = true
      const params = {
        customerId: this.detailId
      }

      if (this.poolId) {
        params.poolId = this.poolId
      }

      crmCustomerReadAPI(params)
        .then(res => {
          this.loading = false
          const resData = res.data || {}
          this.detailData = resData
          this.firstContactsId = this.detailData.contactsId
          // 公海权限
          this.poolAuth = resData.poolAuthList || {}
          // 负责人
          const headDetails = [{ title: '客户级别', value: '' },
            { title: '成交状态', value: '' },
            { title: '负责人', value: '' }]
          if (this.crm.customer && this.crm.customer.mainContact) {
            headDetails.push({ title: '首要联系人', value: '' })
          }
          headDetails[0].value = this.detailData.level

          const dealItem = headDetails[1]
          if (this.detailData.dealStatus === null || this.detailData.dealStatus === '' || this.detailData.dealStatus === undefined) {
            dealItem.showIcon = false
            dealItem.value = ''
          } else {
            dealItem.showIcon = true
            if (this.detailData.dealStatus == 1) {
              dealItem.icon = 'deal-suc'
              dealItem.style = {
                fontSize: '14px',
                color: '#20b559',
                marginRight: '3px'
              }
              dealItem.value = '已成交'
            } else {
              dealItem.icon = 'deal-un'
              dealItem.style = {
                fontSize: '14px',
                color: '#f95a5a',
                marginRight: '3px'
              }
              dealItem.value = '未成交'
            }
          }

          headDetails[2].title = this.isSeasDetail ? '' : '负责人'
          headDetails[2].value = this.detailData.ownerUserName
          if (this.crm.customer && this.crm.customer.mainContact) {
            const contactObj = headDetails[3]
            if (this.firstContactsId) {
              contactObj.value = this.detailData.contactsName
              headDetails.push({
                showPhone: true,
                title: '首要联系人电话',
                value: this.detailData.contactsMobile,
                helpObj: {
                  type: '8',
                  id: '103'
                }
              })
            } else {
              contactObj.addShow = true
              contactObj.addType = 'contacts'
              contactObj.helpObj = {
                type: '8',
                id: '103'
              }
            }
          }

          this.headDetails = headDetails
        })
        .catch(() => {
          this.loading = false
          this.hideView()
        })
      crmSpecialExamineAPI({
        businessType: 2, // 业务类型  1 联系人  2 企业
        businessId: this.detailId
      }).then(res => {
        this.examineButtons = res.data.filter(item => !!item.canInitiate)
      })
    },

    /**
     * 关闭
     */
    hideView() {
      this.$emit('hide-view')
    },

    /**
     * 首要联系人添加
     */
    addChieflyContacts() {
      this.createCRMType = 'contacts'
      this.createActionInfo = {
        type: 'relative',
        crmType: this.crmType,
        data: { customer: this.detailData }
      }
      this.isCreate = true
    },

    /**
     * 顶部头 操作
     * @param {*} data
     */
    detailHeadHandleClick(data) {
      if (data.type === 'edit') {
        if (this.detailData.examineType) {
          this.$confirm(`正在审批的企业无法编辑，如需编辑请撤回审批`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.showExamineDetail = true
            this.examineId = this.detailData.examineId
          })
          return false
        }
        this.createCRMType = 'customer'
        this.createActionInfo = {
          type: 'update',
          id: this.detailId,
          batchId: this.detailData.batchId
        }
        this.isCreate = true
        return false
      }
    },
    /**
     * 审批
     */
    handleExamineClick(info) {
      console.log(info)

      // 转为精准企业
      if (info.examineCode === 'transAccurateCustomer') {
        this.createCRMType = 'customer'
        this.createActionInfo = {
          type: 'update',
          id: this.detailId,
          batchId: this.detailData.batchId,
          data: { specialExamine: true, isTrans: 1 }
        }
        this.isCreate = true
      } else if (info.examineCode === 'examineTypeCancelSka' || info.examineCode === 'examineTypeCancelKa') {
        this.showExamineRemark = true
        Object.assign(this.examineInfo, info)
      } else if (info.examineCode === 'examineTypeChangeVolume' || info.examineCode === 'examineTypeToSka' || info.examineCode === 'examineTypeToKa') {
        // 年潜在体量创建审批弹窗
        Object.assign(this.createExamineInfo, {
          categoryId: info.examineId,
          type: info.examineType,
          categoryTitle: info.examineName,
          content: this.detailData.customerName
        })
        Object.assign(this.createExamineAction, {
          data: {
            customerList: [{ customerId: this.detailId, customerName: this.detailData.customerName }]
          }
        })
        this.isExamineCreate = true
      } else {
        this.$confirm(`是否发起${info.examineName}审批?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.postSpecialExamine(info.examineType, { customerIds: this.detailId }, info.examineId, this.detailData.customerName, '', () => {
            // 更新详情
            this.getDetial()
            this.getTagInfo()
          })
        })
      }
    },

    /**
     * 格式化客户摘要字段值
     * @param item
     * @return {string}
     */
    getDigestFieldValue(item) {
      if (!this.detailData || !this.detailData.digest) return ''
      let value = this.detailData.digest[item.field]
      if (item.isMoney) {
        value = separator(value)
      }
      return `${value}${item.units || ''}`
    },

    /**
     * 详情头部操作
     */
    headAction(type) {
      if (type === 'contacts-add') {
        const crmDetailHead = this.$refs.crmDetailHead
        if (crmDetailHead) {
          crmDetailHead.handleClick('contacts')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/crmdetail.scss";

.slide-fade-leave-active {
  will-change: transform;
  transition: all 0.1s;
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.wk-circle-password {
  padding: 2px;
  margin-left: 5px;
  font-size: 12px;
  color: white;
  background-color: #f56c6c;
  border-radius: 3px;
  transform: scale(0.6);
}

// 摘要
.abstract {
  .crm-tooltip {
    margin-left: 3px;
  }
}
</style>
